import DialogsPlugin from "../dialogsPlugin";

const ConfirmDialog = {
    template: "<modal ref=\"dialog\"></modal>",
    beforeMount() {
        DialogsPlugin.confirmBus.$on("show", params => {
            this.$refs.dialog.show(params).done(res => DialogsPlugin.confirmBus.$emit("close", res));
        });
    }
};

export default ConfirmDialog;